const CONSTANTS = {
  preferredDealerIdCookieName:
    window.cookies && window.cookies.preferred ? window.cookies.preferred : 'preferred',
  zipcodeCookieName:
    window.cookies && window.cookies.zip ? window.cookies.zip : 'zipcode',
  dealerNameCookieName: 'dealername',
  states: {
    default: 'is-default',
    selectDealer: 'is-select-dealer',
  },
  accessoriesStorageKey: 'bapAccessories',
  defaultinventoryAndDealersNode: 0,
  navigationAppearance: 'appearance',
  navigationExteriorColorsAcura: 'exterior-colors',
  navigationInteriorColorsAcura: 'interior-colors',
  navigationExteriorColorsAutos: 'Exterior Color',
  navigationInteriorColorsAutos: 'Interior Color',
  navigationPackages: 'packages',
  navigationPremiumFeatures: 'Premium Features',
  navigationPowertrainAcura: 'powertrain',
  navigationPowertrainAutos: 'Drivetrain Transmission',
  navigationEngine: 'engine',
  navigationDrivetrain: 'drivetrain',
  engagementScoreKey: 'EngagementScore',
  taxonomy: {
    currentModels: 'Current Models',
    previousModels: 'Previous Models',
    vehicle: 'TaxonomyVehicle',
    year: 'ModelYear',
    name: 'TaxonomyName',
    vehicleImage: 'DefaultVehicleImage',
    vehicleImageAlt: 'DefaultVehicleImageAlt',
    vehicles: 'Vehicles',
    packages: 'Packages',
    packageName: 'PackageName',
    packageDescription: 'PackageDescription',
    packageImage: 'PackageImageUrl',
    packageImageAlt: 'PackageImageAlt',
    modelId: 'VehicleModel',
    categoryType: 'category',
    vehicleType: 'vehicle',
    modelsState: 'models',
    selectedState: 'selected',
    defaultState: 'default',
  },
};

export default CONSTANTS;
